/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import get from 'lodash/get';
import { ICheckoutSectionContainerItem, ICheckoutSectionContainerViewProps } from './checkout-section-container';

const ItemComponent: React.FC<ICheckoutSectionContainerItem> = ({ loading, itemProps, item, accordion }) =>
    accordion? 
    (
        <div className= {`accordion-item-container accordion-item-container-${get(item, "props.typeName")}`} >
        {loading}
        {accordion}
        <Node {...itemProps}>{item}</Node>
        </div> 
    ) :
     (
        <>
        {loading}
        <Node {...itemProps}>{item}</Node>
        </>
     );

const CheckoutSectionContainerView: React.FC<ICheckoutSectionContainerViewProps> = ({ checkoutPlainContainerProps, items,reCaptcha, fingerPrintError,attemptError }) => (
    <Module {...checkoutPlainContainerProps}>
        {items.map(item => (
            <ItemComponent key={item.id} {...item} />
        ))}
        {reCaptcha}
        {fingerPrintError}
        {attemptError}
    </Module>
);

export default CheckoutSectionContainerView;
